import React, { useState, useEffect, useRef } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import nav_plus from "../../assets/Vehicles/nav_plus.png";
import help from "../../assets/Vehicles/help.png";
import { useNavigate, useLocation } from "react-router-dom";
import "../Vehicles/Vehicle_list/List.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";
// import ReportAnIssueModal from "../components/common/report-an-issue-modal";
import issue from "../../assets/svg/issue.svg";
import HomePageIc from "../../assets/svg/homepage_ic.svg";
import ReportAnIssueModal from "./report-an-issue-modal";
import { useGlobal } from "../../GlobalContext";
import { getOrgListApi, getOrgLogoApi } from "./common-api";
import { getProfileDetailsApi } from "../dashboard_api";
import ProfilePopup from "./ProfilePopup";

export const Navbar = () => {
  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;

  const navigate = useNavigate();
  const location = useLocation();
  // const [profileDetail, setProfileDetail] = useState({});
  const [showProfile, setShowProfile] = useState(false);
  const [orgName, setOrgName] = useState("");
  const { setHeaderDetails, headerDetails } = useGlobal();

  const isDashboard = location.pathname === "/dashboard";
  const isLocation = location.pathname === "/location";
  const isListPage = location.pathname === "/list";
  const isAssignment = location.pathname === "/assignment";
  const isExpense = location.pathname === "/expenses";
  const isNewExpense = location.pathname === "/newExpense";
  const isNewVehiclePage = location.pathname === "/vehicle-create";
  const isVehicleDetails = location.pathname === "/vehicle-view";
  const isIssue = location.pathname === "/issue-history";
  const isViewIssue = location.pathname === "/viewIssue";
  const isFuel = location.pathname === "/fuel";
  const isKm = location.pathname === "/km";
  const isReport = location.pathname === "/report";
  const isService = location.pathname === "/service";
  const isNewService = location.pathname === "/service/create";
  const isWorkOrder = location.pathname === "/workorder";
  const isNewWorkOrder = location.pathname === "/workorder/create";
  const isViewWorkOrder = location.pathname === "/workorder/view";
  const isReminder = location.pathname === "/reminder";
  const isRenewal = location.pathname === "/renewal";
  const isUpcoming = location.pathname === "/upcoming";
  const isInspection = location.pathname === "/inspection";
  const isNewInspection = location.pathname === "/inspection/create";
  const isViewInspection = location.pathname === "/inspection/view";
  const isVendor = location.pathname === "/vendor";
  const isNewVendor = location.pathname === "/vendor/create";
  const isViewVendor = location.pathname === "/vendor/view";
  const carModel = location.state?.["code"];

  const breadcrumbText = isDashboard
    ? "Dashboard"
    : isLocation
      ? "Location detection"
      : isListPage
        ? "Vehicle list"
        : isAssignment
          ? "Vehicle assignment"
          : isExpense
            ? "Expenses history"
            : isNewExpense
              ? "Expense"
              : isNewVehiclePage
                ? "Vehicle "
                : isIssue
                  ? "Issue history"
                  : isViewIssue
                    ? "Issue history"
                    : isFuel
                      ? "Fuel History"
                      : isKm
                        ? "Km History"
                        : isService
                          ? "Service"
                          : isNewService
                            ? "New Service"
                            : isWorkOrder
                              ? "Work Order"
                              : isNewWorkOrder
                                ? "New Work Order"
                                : isViewWorkOrder
                                  ? "View Work Order"
                                  : isReminder
                                    ? "Service Reminder"
                                    : isRenewal
                                      ? "Renewal"
                                      : isUpcoming
                                        ? "Upcoming Renewal"
                                        : isInspection
                                          ? "Inspection"
                                          : isNewInspection
                                            ? "New Inspection"
                                            : isViewInspection
                                              ? "View Inspection"
                                              : isVendor
                                                ? "Vendor"
                                                : isNewVendor
                                                  ? "New Vendor"
                                                  : isViewVendor
                                                    ? "View Vendor"
                                                    : isReport
                                                      ? "Report"
                                                      : "";
  const [showComplaintModule, setShowComplaintModule] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const popupRef = useRef();
  const [hovered, setHovered] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [orgLogo, setOrgLogo] = useState("");
  const [firstLetter, setFirstLetter] = useState("");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowPopup(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  useEffect(() => {
    getOrgList();
    getOrgLogo();
    if (!headerDetails || Object.keys(headerDetails).length === 0) {
      getProfileDetails();
    }
  }, []);
  const [orgList, setOrgList] = useState([]);
  const getOrgList = async () => {
    console.log("Getting org list");
    const response = await getOrgListApi();
    console.log(response.data);
    if (response.status === 200) {
      console.log(response.data.orgs);
      if (response.data.success === true) {
        setOrgList(response.data.orgs ?? []);
      }
    }
  };
  const getOrgLogo = async () => {
    try {
      const response = await getOrgLogoApi();
      if (response.success === true) {
        /*  setheaderDetails(response.user ?? {}); */
        setOrgLogo(response.image ?? "");
        setOrgName(response.org_name ?? "....");
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getProfileDetails = async () => {
    try {
      const response = await getProfileDetailsApi();

      if (!response) {
        console.error("No response received from API");
        return;
      }

      if (response.status === 200 && response.data?.success) {
        setHeaderDetails(response.data.user);
        // setProfileDetail(response.data.user);
        setFirstLetter(
          response.data.user?.first_name
            ? response.data.user.first_name.charAt(0)
            : "",
        );
      }
    } catch (err) {
      console.error("Error in getProfileDetails:", err);
    }
  };

  return (
    <div style={{ borderBottom: "0.6px solid #EBEBEB" }}>
      {showComplaintModule && (
        <ReportAnIssueModal
          onSuccess={() => {
            setShowComplaintModule(false);
          }}
          onCancel={() => {
            setShowComplaintModule(false);
          }}
        />
      )}
      <div
        className="d-flex justify-content-between align-items-center w-100 bg-white ps-3 py-3"
        style={{
          height: "56px",
        }}
      >
        <Breadcrumb className="m-0">
          <Breadcrumb.Item
            onClick={() => {
              if (isListPage) {
                navigate("/list");
              } else if (isNewVehiclePage) {
                navigate("/list");
              } else if (isNewExpense) {
                navigate("/expenses");
              } else if (isVehicleDetails) {
                navigate("/list");
              } else if (isViewIssue) {
                navigate("/issue-history");
              }
            }}
            className={
              isListPage ||
              isDashboard ||
              isLocation ||
              isAssignment ||
              isExpense ||
              isIssue ||
              isFuel ||
              isService ||
              isWorkOrder ||
              isNewService ||
              isNewWorkOrder ||
              isReminder ||
              isRenewal ||
              isUpcoming ||
              isInspection ||
              isNewInspection ||
              isViewInspection ||
              isVendor ||
              isNewVendor ||
              isKm
                ? "breadcrumb-purple"
                : "breadcrumb-grey"
            }
          >
            {breadcrumbText}
          </Breadcrumb.Item>

          {isNewVehiclePage && (
            <Breadcrumb.Item active className="breadcrumb-purple">
              Add vehicle
            </Breadcrumb.Item>
          )}
          {carModel && !isViewIssue && (
            <Breadcrumb.Item active className="breadcrumb-purple">
              {carModel}
            </Breadcrumb.Item>
          )}
          {/* {isNewExpense && (
            <Breadcrumb.Item active className="breadcrumb-purple">
              Expenses history
            </Breadcrumb.Item>
          )}
          {isViewIssue && (
            <Breadcrumb.Item active className="breadcrumb-purple">
              Oil leakage in Engine
            </Breadcrumb.Item>
          )}
          {isViewWorkOrder && (
            <Breadcrumb.Item active className="breadcrumb-purple">
              View Work Order
            </Breadcrumb.Item>
          )} */}
        </Breadcrumb>

        {/* <p className="text-purple m-0">Vehicle list</p> */}
        <div className="d-flex align-items-center gap-xl-3 gap-1">
          <img
            src={HomePageIc}
            alt="Company Logo"
            className="logo"
            style={{ cursor: "pointer" }}
            onClick={() => {
              window.open(accountsUrl, "_blank", "noopener,noreferrer");
            }}
          />
          <div className="right_divs">
            <button
              onClick={() => {
                setShowComplaintModule(true);
              }}
              type="button"
              className="right_divs px-1"
            >
              <img src={issue} alt="issue" srcSet="" sizes="20" />
              <span>Report an issue</span>
            </button>
          </div>
          {/*  <img src={nav_plus} alt="plus" /> */}
          <div
            className="px-2"
            style={{ cursor: "pointer" }}
            onClick={() => {
              navigate("/help");
            }}
          >
            <img src={help} alt="help" />
          </div>
          {/* <img src={setting} alt="seting" />
          <img src={bell} alt="bell" />
          <img src={user} alt="user" /> */}
          <div
            onClick={() => {
              setShowProfile(!showProfile);
              /* window.open(
                accountsUrl + "/user-detail",
                "_blank",
                "noopener,noreferrer"
              ); */
            }}
            style={{ cursor: "pointer", paddingRight: "16px" }}
          >
            {headerDetails.profile_image != null &&
              headerDetails.profile_image !== "" && (
                <img
                  src={headerDetails.profile_image}
                  style={{ width: "40px", height: "40px", borderRadius: "100px" }}
                  alt="Profile"
                />
              )}
            {(headerDetails.profile_image == null ||
              headerDetails.profile_image === "") && (
              <div
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "100px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#7525B1",
                }}
              >
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "700",
                    color: "#FFFFFF",
                  }}
                >
                  {headerDetails?.first_name
                    ? headerDetails.first_name.charAt(0)
                    : ""}
                </div>
              </div>
            )}
          </div>
          {showProfile && (
            <ProfilePopup
              orgList={orgList}
              profileDetail={headerDetails}
              onClose={() => setShowProfile(false)}
              orgLogo={orgLogo}
              orgName={orgName}
              callProfileFunc={getProfileDetails}
            />
          )}
        </div>
      </div>
    </div>
  );
};
